import _asyncToGenerator from "/var/lib/jenkins/workspace/commonapp-fe-build-UAT/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/workspace/commonapp-fe-build-UAT/client/node_modules/@babel/runtime/regenerator/index.js";

/*!
 * Built with Stencil
 * Copyright ©2024 Common App
 */
import { b as bootstrapLazy } from './index-a4c94f6f.js';
export { s as setNonce } from './index-a4c94f6f.js';
import { g as globalScripts } from './app-globals-c493bc4f.js';

var defineCustomElements = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(win, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window === 'undefined')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", undefined);

          case 2:
            _context.next = 4;
            return globalScripts();

          case 4:
            return _context.abrupt("return", bootstrapLazy([["forge-icon", [[4, "forge-icon", {
              "decorative": [4],
              "library": [1],
              "name": [1],
              "size": [513],
              "viewbox": [1025],
              "pathData": [32],
              "visible": [32]
            }, null, {
              "name": ["loadIconPathData"]
            }]]], ["forge-combobox", [[6, "forge-combobox", {
              "clearable": [4],
              "description": [1],
              "hint": [1],
              "hoisted": [4],
              "label": [1],
              "maxListboxHeight": [2, "maxlistboxheight"],
              "maxSelected": [2, "maxselected"],
              "minSelected": [2, "minselected"],
              "multiselect": [4],
              "placeholder": [1],
              "required": [4],
              "showValidation": [1028, "showvalidation"],
              "valid": [1028],
              "validationMessage": [1025, "validationmessage"],
              "value": [1025],
              "hasValue": [32],
              "listboxOpen": [32],
              "listboxActive": [32],
              "selectedOptions": [32],
              "open": [64],
              "close": [64],
              "addValue": [64],
              "setValue": [64],
              "removeValue": [64],
              "getValue": [64],
              "validate": [64],
              "reset": [64]
            }, [[5, "mousedown", "handleMousedown"], [5, "mouseup", "handleMouseup"]], {
              "showValidation": ["validationMessageConnector"],
              "value": ["valueHandler"],
              "filteredOptions": ["updateFirstLastOption"]
            }]]], ["forge-checkbox", [[4, "forge-checkbox", {
              "checked": [1540],
              "hint": [1],
              "hideRequired": [4, "hiderequired"],
              "indeterminate": [1028],
              "label": [1],
              "name": [1],
              "required": [4],
              "showValidation": [1028, "showvalidation"],
              "showValidationGrouped": [1028, "showvalidationgrouped"],
              "unlabeled": [4],
              "valid": [1028],
              "validationMessage": [1025, "validationmessage"],
              "value": [1025],
              "isValid": [64],
              "validate": [64]
            }, null, {
              "checked": ["checkedHandler"],
              "indeterminate": ["indeterminateHandler"],
              "showValidation": ["attachErrorHandler"]
            }]]], ["forge-select", [[6, "forge-select", {
              "autocomplete": [1],
              "clearable": [4],
              "description": [1],
              "hint": [1],
              "label": [1],
              "placeholder": [1],
              "required": [4],
              "showValidation": [1028, "showvalidation"],
              "validationMessage": [1025, "validationmessage"],
              "value": [1537],
              "valid": [32],
              "getValue": [64],
              "setValue": [64],
              "reset": [64],
              "isValid": [64],
              "validate": [64]
            }, null, {
              "showValidation": ["attachErrorHandler"]
            }]]], ["forge-checkbox-group", [[4, "forge-checkbox-group", {
              "description": [1],
              "legend": [1],
              "maxChecked": [2, "maxchecked"],
              "minChecked": [2, "minchecked"],
              "required": [4],
              "showValidation": [1028, "showvalidation"],
              "valid": [1028],
              "validationMessage": [1025, "validationmessage"],
              "checkedItems": [1040],
              "getValue": [64],
              "setValue": [64],
              "reset": [64],
              "isValid": [64],
              "validate": [64]
            }, [[0, "checkboxChecked", "checkboxCheckedHandler"]], {
              "checkedItems": ["valueValidityHandler"],
              "showValidation": ["attachErrorHandler"]
            }]]], ["forge-input", [[6, "forge-input", {
              "autocomplete": [1],
              "description": [1],
              "hint": [1],
              "label": [1],
              "maxLength": [2, "maxlength"],
              "minLength": [2, "minlength"],
              "name": [1025],
              "pattern": [1],
              "patternTitle": [1, "patterntitle"],
              "placeholder": [1],
              "readonly": [4],
              "required": [4],
              "showValidation": [1028, "showvalidation"],
              "type": [1],
              "valid": [1028],
              "validationMessage": [1025, "validationmessage"],
              "value": [1025],
              "isValid": [64],
              "validate": [64]
            }, null, {
              "value": ["valueValidityHandler"],
              "showValidation": ["attachErrorHandler"]
            }]]], ["forge-radio-group", [[4, "forge-radio-group", {
              "legend": [1],
              "description": [1],
              "name": [1],
              "orientation": [1025],
              "required": [4],
              "showValidation": [1028, "showvalidation"],
              "valid": [1028],
              "validationMessage": [1025, "validationmessage"],
              "checkedItem": [1032, "checked-item"],
              "getValue": [64],
              "setValue": [64],
              "reset": [64],
              "isValid": [64],
              "validate": [64]
            }, [[0, "radioChecked", "radioCheckedHandler"]], {
              "checkedItem": ["valueValidityHandler"],
              "showValidation": ["attachErrorHandler"]
            }]]], ["forge-accordion", [[4, "forge-accordion", {
              "open": [1028],
              "isOpen": [32],
              "toggleAccordion": [64]
            }]]], ["forge-anchor", [[6, "forge-anchor", {
              "external": [4],
              "externalIcon": [1, "externalicon"],
              "inline": [4],
              "link": [1],
              "linkTarget": [1, "linktarget"],
              "rel": [1025],
              "size": [1]
            }]]], ["forge-loading", [[6, "forge-loading", {
              "delay": [2],
              "fullscreen": [4],
              "icon": [1],
              "label": [1],
              "labelPosition": [1, "labelposition"],
              "showLabel": [4, "showlabel"],
              "size": [1],
              "speed": [2],
              "visible": [1540],
              "start": [64],
              "stop": [64]
            }, [[0, "keydown", "trapFocus"]]]]], ["forge-accordion-group", [[4, "forge-accordion-group", {
              "multiple": [4],
              "requireOpenPanel": [4, "requireopenpanel"]
            }, [[0, "keydown", "handleKeydown"], [0, "accordionToggled", "toggleOthers"]]]]], ["forge-button", [[6, "forge-button", {
              "buttonType": [1025, "buttontype"],
              "color": [1],
              "fill": [1],
              "size": [1]
            }]]], ["forge-radio", [[4, "forge-radio", {
              "checked": [1540],
              "hint": [1],
              "label": [1],
              "name": [1],
              "required": [4],
              "showValidation": [4, "showvalidation"],
              "value": [1025]
            }, null, {
              "checked": ["checkedHandler"]
            }]]], ["forge-tooltip", [[6, "forge-tooltip", {
              "delayEnter": [2, "delayenter"],
              "delayExit": [2, "delayexit"],
              "hoisted": [4],
              "maxWidth": [1, "maxwidth"],
              "open": [1028],
              "placement": [1],
              "target": [1],
              "type": [1],
              "showTooltip": [64],
              "hideTooltip": [64]
            }, null, {
              "open": ["tooltipOpenHandler"]
            }]]], ["forge-screen-reader-text", [[1, "forge-screen-reader-text", {
              "pause": [513]
            }]]], ["forge-combobox-chip_2", [[6, "forge-option", {
              "focused": [4],
              "label": [1],
              "selected": [4],
              "value": [1537]
            }, null, {
              "selected": ["selectedHandler"]
            }], [2, "forge-combobox-chip", {
              "value": [1],
              "removeHandler": [16]
            }]]], ["forge-message", [[4, "forge-message", {
              "dismissible": [4],
              "inline": [4],
              "live": [4],
              "messageType": [1, "type"],
              "closeMessage": [64]
            }]]]], options));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function defineCustomElements(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export { defineCustomElements };